import { Link } from "react-router-dom"

export default function Footer() {
  return (
    <footer>
      <div class="copyright">
        &copy; Deepvin, Inc. All rights reserved.<br />
        <Link to="/disclaimer">Disclaimer</Link>&nbsp;&nbsp;
        <Link to="/privacy">Privacy Statement</Link>    
      </div>
    </footer>
  )
}